'use client';

import { useEffect, useState } from 'react';

import Icon from '../ui/AppIcon';
import { useTheme } from 'next-themes';

interface ThemeToggleProps {
  className?: string;
  iconClassName?: string;
}

export function ThemeToggle({ className, iconClassName }: ThemeToggleProps) {
  const [mounted, setMounted] = useState(false);
  const { theme, setTheme, resolvedTheme } = useTheme();

  // This is a legitimate use case for useEffect with setState
  // We need to wait for hydration to avoid server/client mismatch
  // eslint-disable-next-line react-compiler/react-compiler
  useEffect(() => {
    setMounted(true);
  }, []);

  const currentTheme = resolvedTheme || theme || 'light';

  return (
    <button
      onClick={() => setTheme(currentTheme === 'dark' ? 'light' : 'dark')}
      className={`w-10 h-10 rounded-xl bg-card border border-border hover:bg-accent transition-colors flex items-center justify-center group ${className}`}
      aria-label="Toggle theme"
      suppressHydrationWarning
    >
      {!mounted ? (
        <div className="w-5 h-5 rounded-full bg-muted animate-pulse" />
      ) : currentTheme === 'dark' ? (
        <Icon 
          name="SunIcon" 
          size={20} 
          className={`text-foreground group-hover:text-accent-foreground transition-colors ${iconClassName}`} 
        />
      ) : (
        <Icon 
          name="MoonIcon" 
          size={20} 
          className={`text-foreground group-hover:text-accent-foreground transition-colors ${iconClassName}`} 
        />
      )}
    </button>
  );
}